// src/components/SEOPages.jsx
import React from 'react';
import SEO from './SEO';

export const DashboardSEO = () => (
    <SEO
        title="Admin Dashboard - Chema Platform"
        description="Comprehensive admin dashboard for managing member contributions, death claims, and voucher payments on Chema platform."
        keywords="admin dashboard, member management, claims processing, voucher verification"
        ogType="website"
    />
);

export const MembersSEO = () => (
    <SEO
        title="Member Management - Chema Admin"
        description="Manage member registrations, verifications, and profiles on Chema platform. Review and approve new member applications."
        keywords="member management, user verification, member profiles, registration approval"
        ogType="website"
    />
);

export const ClaimsSEO = () => (
    <SEO
        title="Claims Management - Chema Admin"
        description="Process and verify death claims on Chema platform. Review documentation and approve legitimate claims for member support."
        keywords="death claims, claims processing, claim verification, support payments"
        ogType="website"
    />
);

export const VouchersSEO = () => (
    <SEO
        title="Voucher Management - Chema Admin"
        description="Manage voucher payments and verifications on Chema platform. Track contributions and verify payment authenticity."
        keywords="voucher management, payment verification, contribution tracking, voucher system"
        ogType="website"
    />
);

export const EmployeesSEO = () => (
    <SEO
        title="Employee Management - Chema Admin"
        description="Manage staff accounts and role-based access control for Chema platform administration."
        keywords="employee management, staff accounts, role-based access, admin permissions"
        noindex={true} // Keep employee pages out of search engines
    />
);

export const ProfileSEO = () => (
    <SEO
        title="Admin Profile - Chema Platform"
        description="Manage your administrator profile, security settings, and preferences on Chema platform."
        keywords="admin profile, account settings, security preferences, user management"
        noindex={true}
    />
);

export const SettingsSEO = () => (
    <SEO
        title="Platform Settings - Chema Admin"
        description="Configure platform settings, payment options, notification preferences, and security settings for Chema platform."
        keywords="platform settings, configuration, payment setup, security settings"
        noindex={true}
    />
);